import { Injectable } from '@angular/core';
import { COOKIE_DOMAIN } from '../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class CookieHelperService {
  setCookieName(
    cookieName: string,
    cookieValue: string | boolean | number,
    expireDays: number,
    keepSession: boolean,
    pathValue = '',
    domainValue?: string
  ) {
    const cookiesLife = new Date();
    if (expireDays > 0 || keepSession) {
      cookiesLife.setTime(
        cookiesLife.getTime() + expireDays * 24 * 60 * 60 * 1000
      );

      const expires = keepSession
        ? ''
        : '; expires=' + cookiesLife.toUTCString();
      const path = this._getCookiePath(pathValue);
      let cookieDetails = cookieName + '=' + cookieValue + expires + path;
      cookieDetails = this._getCookieDetails(domainValue, cookieDetails);
      document.cookie = cookieDetails;
    }
  }

  private _getCookieDetails(
    domainValue: string | undefined,
    cookieDetails: string
  ) {
    const { hostname } = window.location;

    return domainValue
      ? `${cookieDetails};domain=${
          hostname === 'localhost' ? 'localhost' : domainValue
        }`
      : cookieDetails;
  }

  private _getCookiePath(pathValue: string) {
    let path = '';
    if (pathValue) {
      path = `;path=${pathValue}`;
    }
    return path;
  }

  getCookieValue(cookieName: string) {
    const result = new RegExp(
      '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
    ).exec(document.cookie);
    return result ? result[1] : null;
  }

  deleteCookie(cookieName: string) {
    const date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    // Set it
    document.cookie =
      cookieName + '=; expires=' + date.toUTCString() + COOKIE_DOMAIN;
  }

  getAccountCookie(cookieName: string) {
    const name = cookieName + '=';
    const temp = document.cookie.split(';');
    for (let i = 0; i < temp.length; i++) {
      let ca = temp[i];
      while (ca.charAt(0) === ' ') {
        ca = ca.substring(1);
      }
      if (ca.indexOf(name) === 0) {
        return ca.substring(name.length, ca.length);
      }
    }
    return '';
  }

  getCountryCode() {
    let countryCode = '';
    const prefCookie = this.getCookieValue('prefUI');
    if (prefCookie) {
      const res = prefCookie.split('=');
      if (res?.length >= 2 && res[1]) {
        countryCode = res[1].split('-')[1]?.toLowerCase();
      }
    }
    return countryCode;
  }
}
